module.exports = __webpack_public_path__ + "routes/urzad/szczegolyUrzedu/godlo-Polski.png?bbfe20a4";


//////////////////
// WEBPACK FOOTER
// ./routes/urzad/szczegolyUrzedu/godlo-Polski.png
// module id = 1837
// module chunks = 0